export default "__VITE_ASSET__CufenQ_9__"